/**
 * FVrad - Cosmic radiation exposure tracking for frequent flyers
 * Field Viewers Inc.
 *
 * @format
 */

import React, { useEffect } from 'react';
import { StatusBar, useColorScheme, LogBox } from 'react-native';
import { SafeAreaProvider } from 'react-native-safe-area-context';
import { NavigationContainer } from '@react-navigation/native';
import { RootNavigator } from './src/navigation';
import { CameraPermissionRequest } from './src/components/CameraPermissionRequest';

function App() {
  const isDarkMode = useColorScheme() === 'dark';

  useEffect(() => {
    // Disable React Native dev banner/log box completely
    LogBox.ignoreAllLogs(true);
    // Specifically hide Metro connection banner and dev overlays
    LogBox.ignoreLogs([
      'Connect to Metro',
      'Metro',
      'Unable to connect to Metro',
      'No connection to Metro',
      'Failed to connect to Metro',
      'Loading from Metro',
      'Remote debugger',
      'Dev menu',
    ]);
  }, []);

  return (
    <SafeAreaProvider>
      <StatusBar barStyle={isDarkMode ? 'light-content' : 'dark-content'} />
      <CameraPermissionRequest>
        <NavigationContainer>
          <RootNavigator />
        </NavigationContainer>
      </CameraPermissionRequest>
    </SafeAreaProvider>
  );
}

export default App;
